module.exports = __webpack_public_path__ + "img/icon_map_6_off_101.87f5dbdc.png";